/*
  Frete grátis (Revélatte). Valores em Configurações do tema > Frete grátis.

  - Barra do topo (sections/frete-gratis-barra.liquid): quando o carrinho muda
    fora da página do carrinho, pede a seção de novo ao Shopify e troca o
    conteúdo. O texto mora só no Liquid.
  - Linha do kit (snippets/frete-gratis-kit.liquid): refaz a conta de quantas
    caixas faltam somando o carrinho e a escolha atual no kit.

  O combo segue os descontos automáticos da loja (2 caixas 3% off, 3+ caixas
  6% off). Se eles mudarem, atualize aqui e em snippets/frete-gratis-calculo.liquid.
*/
(function () {
  var SECAO = 'frete-gratis-barra';

  function atualizaBarra() {
    var atual = document.querySelector('#shopify-section-' + SECAO + ' [data-frete-barra]');
    if (!atual || atual.dataset.estatico === 'true') return;
    fetch('/?sections=' + SECAO)
      .then(function (r) { return r.json(); })
      .then(function (secoes) {
        var html = secoes[SECAO] || '';
        var nova = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-frete-barra]');
        if (nova) atual.replaceWith(nova);
      })
      .catch(function () {});
  }

  var kit = window.RevelatteFrete && window.RevelatteFrete.kit;

  function fator(n) { return n >= 3 ? 94 : n >= 2 ? 97 : 100; }
  function valorCafe(n) { return Math.round((n * kit.preco * fator(n)) / 100); }
  function caixasQueFaltam(qtd) {
    for (var k = 0; k < 10; k++) {
      if (valorCafe(qtd + k) + kit.outros >= kit.limite) return k;
    }
    return -1;
  }

  function atualizaKit() {
    var linha = document.querySelector('[data-frete-kit]');
    if (!kit || !linha || !kit.preco) return;
    var bundle = document.querySelector('sachet-bundle');
    var escolhidas = bundle && typeof bundle.getState === 'function' ? bundle.getState().totalBoxes : 0;
    var k = caixasQueFaltam(kit.qtd + escolhidas);
    var texto = '';
    if (k === 0) texto = 'Frete grátis neste pedido*';
    else if (k > 0 && !kit.itens && !escolhidas) texto = 'Frete grátis a partir de ' + k + ' caixas*';
    else if (k > 0) texto = 'Mais ' + k + (k === 1 ? ' caixa' : ' caixas') + ' e o frete sai grátis*';
    linha.textContent = texto;
    linha.hidden = !texto;
    linha.classList.toggle('fg-kit--ok', k === 0);
  }

  function releCarrinho() {
    if (!kit) return;
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (carrinho) {
        var qtd = 0;
        var cafe = 0;
        carrinho.items.forEach(function (item) {
          if (item.handle === kit.produto) {
            qtd += item.quantity;
            cafe += item.final_line_price;
          }
        });
        kit.qtd = qtd;
        kit.outros = carrinho.total_price - cafe;
        kit.itens = carrinho.item_count;
        atualizaKit();
      })
      .catch(function () {});
  }

  function aoMudarCarrinho() {
    atualizaBarra();
    releCarrinho();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, aoMudarCarrinho);
  }
  // Voltar pelo navegador pode trazer a página antiga do cache.
  window.addEventListener('pageshow', function (evento) {
    if (evento.persisted) aoMudarCarrinho();
  });

  // Kit: refaz a conta depois de cada clique (o sachet-bundle.js atualiza antes).
  document.addEventListener('click', function (evento) {
    if (evento.target.closest && evento.target.closest('sachet-bundle')) setTimeout(atualizaKit, 0);
  });
  if (kit && window.customElements) {
    customElements.whenDefined('sachet-bundle').then(atualizaKit);
  }
})();
